import { render } from "./search-drawer.vue?vue&type=template&id=efd7975c"
import script from "./search-drawer.vue?vue&type=script&lang=js"
export * from "./search-drawer.vue?vue&type=script&lang=js"

import "./search-drawer.vue?vue&type=style&index=0&id=efd7975c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__